export default (
    component_name,
    months,
    options = {
        multiple: false,
        initialValues: undefined,
    }
) => ({
    months: months,
    selectedMonths: null,

    toggleSelectAll: false,
    isSubmitted    : false,
    isDisabled     : false,

    init() {
        this.$watch('selectedMonths', (value, old) => {
            if (options.multiple && options.multiple === true) {
                const sortedDays = [...this.selectedMonths].sort((a, b) => a - b);
                this.$dispatch(`${component_name}-change`, [sortedDays, this.isValid]);
                return;
            }
            this.$dispatch(`${component_name}-change`, [value, this.isValid]);
        });

        this.$watch('toggleSelectAll', value => {
            if (value) {
                this.selectedMonths = Array.from({ length: 12 }, (v, i) => i + 1); //? Seleccionar todos los dias
            } else {
                this.selectedMonths = [];
            }
        });

        if (options.initialValues !== undefined && options.initialValues !== null) {
            this.selectedMonths = options.multiple && options.multiple === true ? [...options.initialValues] : options.initialValues;
        }else{
            this.selectedMonths = options.multiple && options.multiple === true ? [] : undefined;
        }
    },

    get isValid() {
        if (options.required === true) {
            return options.multiple
                ? this.selectedMonths.length > 0
                : this.selectedMonths !== undefined;
        }
        return true;
    }
});
